<div class="dashboard-header">
  <div class="dashboard-info">
    <h2>Assessment management</h2>
    <p>
      Manage every proctored assessment integrated with the BeExpert SDK, its
      assigned ruleset, and candidate activity.
    </p>
  </div>

  <button class="add-assessment-btn" (click)="openAddAssessmentDialogBox()"
    *hasPermission="PermissionForStudents.PROCTORING_CREATE">
    <i class="bi bi-plus-lg"></i>
    Add Assessment
  </button>
</div>

<ng-container *ngIf="isInitialLoad; else showPage">
  <div class="app-spinner">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
</ng-container>

<ng-template #showPage>
  <ng-container *ngIf="assessmentData.length > 0 || searchText; else showMessage">
    <hr class="dashboard-divider" />
    <div class="table-wrapper">
      <div class="table-filters">
        <div class="search-row">
          <div class="search-box">
            <i class="fa fa-search" *ngIf="!searchText"></i>
            <i *ngIf="searchText" class="bi bi-x" (click)="searchText = ''; onSearch()" style="cursor: pointer; font-size: 1.2rem; z-index: 10;"></i>
            <input
              type="text"
              placeholder="Search by Assessment Name..."
              [(ngModel)]="searchText"
              (input)="onSearch()"
            />
          </div>
        </div>

        <!-- <div class="filter-row">
          <div class="filter-item">
            <select [(ngModel)]="allRuleSets"
             (change)="applyFilters()">
              <option *ngFor="let item of assessments" [value]="item">
                {{ item }}
              </option>
            </select>
          </div>

          <div class="filter-item">
            <select [(ngModel)]="selectedStatus"
             (change)="applyFilters()">
              <option *ngFor="let item of statuses" [value]="item">
                {{ item }}
              </option>
            </select>
          </div>

          <div class="filter-item">
            <input
              type="date"
              [(ngModel)]="fromDate"
              matTooltip="Start Date"
              matTooltipPosition="above"
               (change)="applyFilters()"
            />
          </div>

          <div class="filter-item">
            <input
              type="date"
              [(ngModel)]="toDate"
              matTooltip="End Date"
              matTooltipPosition="above"
            />
          </div>

          <div class="filter-item integrity-filter">
            <button
              type="button"
              class="filter-btn"
              (click)="toggleIntegrityPopup()"
            >
              <i class="fa fa-sliders"></i>
              Integrity Score
              <i class="fa fa-chevron-down"></i>
            </button>

            <div class="integrity-popup" *ngIf="showIntegrityPopup">
              <div class="integrity-range">
                <div class="range-field">
                  <label>Minimum</label>
                  <input
                    type="number"
                    [(ngModel)]="minIntegrity"
                    placeholder="0"
                  />
                </div>

                <div class="range-field">
                  <label>Maximum</label>
                  <input
                    type="number"
                    [(ngModel)]="maxIntegrity"
                    placeholder="100"
                  />
                </div>
              </div>

              <div class="popup-actions">
                <button class="cancel-btn" (click)="resetIntegrityFilter()">
                  Reset
                </button>

                <button class="apply-btn" (click)="applyIntegrityFilter()">
                  Apply
                </button>
              </div>
            </div>
          </div>
        </div> -->
      </div>

      <div class="report-table">
        <div class="table-responsive">
        <table>
          <thead>
            <tr>
              <th>
                ASSESSMENT CODE
                <span class="material-icons sort-icon" (click)="sortBy('proctoringEvaluationOnId')"> swap_vert </span>
              </th>
              <th>
                ASSESSMENT NAME
                <span class="material-icons sort-icon" (click)="sortBy('evaluationTitle')"> swap_vert </span>
              </th>

              <th>
                RULESET
                <!-- <span class="material-icons sort-icon" (click)="sortBy('ruleSetName')"> swap_vert </span> -->
              </th>

              <!-- <th>
                SESSION
                <span class="material-icons sort-icon" (click)="sortBy('sessionCount')"> swap_vert </span>
              </th> -->

              <th>
                CREATED ON
                <span class="material-icons sort-icon" (click)="sortBy('createdAt')"> swap_vert </span>
              </th>

              <th>ACTIONS</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngIf="isLoading">
              <td colspan="5" style="padding: 40px 0; text-align: center;">
                <mat-spinner diameter="50" style="margin: 0 auto;"></mat-spinner>
              </td>
            </tr>
            <ng-container *ngIf="!isLoading && assessmentData.length > 0">
            <tr *ngFor="let assessment of assessmentData">
              <td>
                <span [matTooltip]="assessment.proctoringEvaluationOnId || '-'">
               {{assessment.proctoringEvaluationOnId?.length > 10 ? (assessment.proctoringEvaluationOnId | slice:0:10) + '...': (assessment.proctoringEvaluationOnId || '-')}}
                </span>
              </td>

              <td>
                <span [matTooltip]="assessment.evaluationTitle || '-'">
                {{ (assessment.evaluationTitle?.length ?? 0) > 20 ? (assessment.evaluationTitle | slice:0:20) + '...': (assessment.evaluationTitle || '-')}}
               </span>
              </td>

              <td>
              <span [matTooltip]="assessment.ruleSetName || '-'">
                {{(assessment.ruleSetName?.length ?? 0) > 20 ? (assessment.ruleSetName | slice:0:20) + '...': (assessment.ruleSetName || '-')}}
              </span>
              </td>
              <!-- <td>
                {{ assessment.sessionCount || "0" }}
              </td> -->
              <td>
                {{ assessment.createdAt | date: "dd MMM yyyy" }}
              </td>

              <td>
                <!-- <ng-container *hasPermission="PermissionForStudents.PROCTORING_READ">
                <span class="view-report" (click)="goToAssessmentDetailPage(assessment.policyBindingId)">
                  <i class="bi bi-eye"></i>
                  View
                </span>
                </ng-container> -->
                
                <ng-container *hasPermission="PermissionForStudents.PROCTORING_UPDATE">
                <span (click)="openEditAssessmentDialog(assessment)"><i class="bi bi-pencil ms-3"></i>
                  Edit </span>
                </ng-container>

                <ng-container *hasPermission="PermissionForStudents.PROCTORING_DELETE">
                <span
                (click)="openDeleteDialogBox(assessment.policyBindingId, assessment.evaluationTitle)"
                ><i class="bi bi-trash ms-3"></i>
                  Delete </span>
              </ng-container>
              </td>
            </tr>
            </ng-container>
            <tr *ngIf="!isLoading && assessmentData.length === 0">
              <td colspan="5">
                <div class="empty-state" style="padding: 40px; text-align: center; color: #64748b; font-size: 14px;">
                  No result found with this name. Please try searching with another name.
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        </div>

        <div class="table-pagination" *ngIf="assessmentData.length > 0">
          <div class="pagination-left">
            Showing <b>{{startRecord}} - {{endRecord}}</b> of <b>{{ total }}</b>

            <span>Rows per page</span>

            <select [(ngModel)]="pageSize" (change)="changePageSize()">
              <option [ngValue]="5">5</option>
              <option [ngValue]="10">10</option>
              <option [ngValue]="25">25</option>
              <option [ngValue]="50">50</option>
            </select>
          </div>

          <div class="pagination-right">
            <button [disabled]="currentPage === 1"
              (click)="previousPage()">Previous</button>

            <span> Page 
              <select [(ngModel)]="currentPage" (ngModelChange)="goToPage($event)">
                <option *ngFor="let page of pagesArray" [ngValue]="page">{{ page }}</option>
              </select>
              of {{ displayTotalPages }} 
            </span>

            <button [disabled]="currentPage === totalPages"
            (click)="nextPage()">Next</button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #showMessage>
    <div class="empty-state" style="padding: 40px; text-align: center; color: #64748b; font-size: 14px;">No assessment available</div>
  </ng-template>
</ng-template>
